import { render, staticRenderFns } from "./Whychoose.vue?vue&type=template&id=7d57e832&scoped=true"
import script from "./Whychoose.vue?vue&type=script&lang=js"
export * from "./Whychoose.vue?vue&type=script&lang=js"
import style0 from "./Whychoose.vue?vue&type=style&index=0&id=7d57e832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d57e832",
  null
  
)

export default component.exports